
        var result = require("!!../../../../../node_modules/css-loader/index.js?sourceMap!../../../../../node_modules/postcss-loader/lib/index.js!../../../../../node_modules/sass-loader/dist/cjs.js?sourceMap!./file.scss");

        if (typeof result === "string") {
            module.exports = result;
        } else {
            module.exports = result.toString();
        }
    